<template>
  <div>
    <div class="main-wrapper signin-form add_account_form center">
	  <h3 class="text-align-center margin-bottom-35">Edit Account</h3>
    <managerform :org_name="org_name" :first_name="first_name" :last_name="last_name" :phone_number="phone_number" :email_addr="email_addr" :password="password" :pw_confirm="pw_confirm" :options="options" :roles="roles" :submit="submit" :action="action"></managerform>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import managerform from './managerform.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      org_name: '',
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
      password: '',
      pw_confirm: '',
      options: [{name: 'Manager', checked: false, id: 2}, {name: 'Mentor', checked: false, id: 3}, {name: 'Primary_admin', checked: false, id: 4}, {name: 'Instructor', checked: false, id: 5}],
      roles: [],
      submit: 'Edit Account Details',
      action: 'update',
    };
  },
  components: {
    managerform,
  },
  methods: {
  	validate() {
  	  this.$validator.validateAll();
    },
    onSubmit () {
   }
 },
}
</script>



// WEBPACK FOOTER //
// src/components/admin/edit_account.vue